class S71Manifesto extends HTMLElement {
  constructor() {
    super();
    this.text = this.querySelector('[data-s71-manifesto-text]');
    this.lines = Array.from(this.querySelectorAll('[data-s71-line]'));
    this.overlap = Math.max(0.4, Number(this.dataset.overlap || 1.6));
    this.onScroll = this.onScroll.bind(this);
  }

  connectedCallback() {
    if (!this.text) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.update();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.update();
    });
  }

  update() {
    const rect = this.text.getBoundingClientRect();
    if (rect.height === 0) return;

    const viewport = window.innerHeight;
    const start = viewport * 0.9;
    const settled = Math.max(0, (viewport - rect.height) / 2);
    const span = Math.max(1, start - settled);
    const progress = Math.min(1, Math.max(0, (start - rect.top) / span));

    const count = this.lines.length;
    const head = progress * (count + this.overlap);

    this.lines.forEach((line, index) => {
      const p = Math.min(1, Math.max(0, (head - index) / this.overlap));
      line.style.setProperty('--s71-line-p', p.toFixed(3));
    });
  }
}

customElements.define('s71-manifesto', S71Manifesto);
